export default __webpack_public_path__ + "static/media/chevrons-right.675f5302.svg";